import { ConsolidateCenterLayerByJornadaUseCase } from '@/application/centerLayer/consolidateCenterLayerByJornadaUseCase';
import { ExtractAreasUseCase } from '@/application/centerLayer/extractAreasUseCase';
import { ExtractCareersUseCase } from '@/application/centerLayer/extractCareersUseCase';
import { ExtractRiskIndicatorsUseCase } from '@/application/centerLayer/extractRiskIndicatorsUseCase';
import { FilterFutureCenterLayerDataUseCase } from '@/application/centerLayer/filterFutureCenterLayerDataUseCase';
import { GetCenterLayerUseCase } from '@/application/centerLayer/getCenterLayerUseCase';
import { ProcessCenterLayerDataUseCase } from '@/application/centerLayer/processCenterLayerDataUseCase';
import { centerLayerApiRepository } from '@/infra';

let _getCenterLayerUseCase: GetCenterLayerUseCase | null = null;
let _filterFutureCenterLayerDataUseCase: FilterFutureCenterLayerDataUseCase | null =
  null;
let _consolidateCenterLayerByJornadaUseCase: ConsolidateCenterLayerByJornadaUseCase | null =
  null;
let _extractRiskIndicatorsUseCase: ExtractRiskIndicatorsUseCase | null = null;
let _extractAreasUseCase: ExtractAreasUseCase | null = null;
let _extractCareersUseCase: ExtractCareersUseCase | null = null;
let _processCenterLayerDataUseCase: ProcessCenterLayerDataUseCase | null = null;

export const getCenterLayerUseCase = (): GetCenterLayerUseCase => {
  if (!_getCenterLayerUseCase)
    _getCenterLayerUseCase = new GetCenterLayerUseCase(
      centerLayerApiRepository,
    );

  return _getCenterLayerUseCase;
};

export const filterFutureCenterLayerDataUseCase =
  (): FilterFutureCenterLayerDataUseCase => {
    if (!_filterFutureCenterLayerDataUseCase) {
      _filterFutureCenterLayerDataUseCase =
        new FilterFutureCenterLayerDataUseCase();
    }

    return _filterFutureCenterLayerDataUseCase;
  };

export const consolidateCenterLayerByJornadaUseCase =
  (): ConsolidateCenterLayerByJornadaUseCase => {
    if (!_consolidateCenterLayerByJornadaUseCase) {
      _consolidateCenterLayerByJornadaUseCase =
        new ConsolidateCenterLayerByJornadaUseCase();
    }
    return _consolidateCenterLayerByJornadaUseCase;
  };

export const extractRiskIndicatorsUseCase =
  (): ExtractRiskIndicatorsUseCase => {
    if (!_extractRiskIndicatorsUseCase) {
      _extractRiskIndicatorsUseCase = new ExtractRiskIndicatorsUseCase();
    }
    return _extractRiskIndicatorsUseCase;
  };

export const extractAreasUseCase = (): ExtractAreasUseCase => {
  if (!_extractAreasUseCase) {
    _extractAreasUseCase = new ExtractAreasUseCase();
  }
  return _extractAreasUseCase;
};

export const extractCareersUseCase = (): ExtractCareersUseCase => {
  if (!_extractCareersUseCase) {
    _extractCareersUseCase = new ExtractCareersUseCase();
  }
  return _extractCareersUseCase;
};

export const processCenterLayerDataUseCase =
  (): ProcessCenterLayerDataUseCase => {
    if (!_processCenterLayerDataUseCase) {
      _processCenterLayerDataUseCase = new ProcessCenterLayerDataUseCase();
    }
    return _processCenterLayerDataUseCase;
  };

export const resetCenterLayerContainer = (): void => {
  _getCenterLayerUseCase = null;
  _filterFutureCenterLayerDataUseCase = null;
  _consolidateCenterLayerByJornadaUseCase = null;
  _extractRiskIndicatorsUseCase = null;
  _extractAreasUseCase = null;
  _extractCareersUseCase = null;
  _processCenterLayerDataUseCase = null;
};
